module.exports = __webpack_public_path__ + "static/img/wall-conveyor-perpendicular-steel_64.b777e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-perpendicular-steel_64.png
// module id = xXZY
// module chunks = 0